import styled from "../styled";

export const StyledBugerMenu = styled.div`
    display: none;
    position: relative;
    z-index: 10;
    max-width: fit-content;

    .line {
        display: block;
        width: 30px;
        height: 2px;
        background-color: ${(props) => (props.$darkColors ? "#262829;" : "#fff")};
        margin: 5px 0;
        transition: 0.2s;
    }

    &.clicked .line-1 {
        transform: rotate(45deg);
        position: absolute;
    }

    &.clicked .line-2 {
        display: none;
    }

    &.clicked .line-3 {
        transform: rotate(-45deg);
    }
`;
